// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getProgressiveLensTypes } from "../../../api";

export const useProgressiveLensTypes = () => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<string>>({
    queryKey: ["progressive-lenstypes"],
    queryFn: async () => {
      const token = await getToken();
      return getProgressiveLensTypes(token);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
